import { useEffect } from 'react';

// Custom hook for exposing rerenderMath globally
export const useGlobalRerenderMath = (rerenderMath: () => Promise<void>) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.rerenderMathJax = rerenderMath;
    }

    return () => {
      if (typeof window !== 'undefined') {
        // @ts-ignore
        delete window.rerenderMathJax;
      }
    };
  }, [rerenderMath]);
};